import { render } from "./DisplayImageDetails.vue?vue&type=template&id=00d89164&scoped=true"
import script from "./DisplayImageDetails.vue?vue&type=script&lang=js"
export * from "./DisplayImageDetails.vue?vue&type=script&lang=js"

import "./DisplayImageDetails.vue?vue&type=style&index=0&id=00d89164&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d89164"]])

export default __exports__